module.exports = __webpack_public_path__ + "img/icone_studio_aixangers-1.6e919e41.png";